<div>
  <div class="ui-fluid">
    <p-table #dt
             [value]="model.rows"
             [globalFilterFields]="filterableColumnKeys"
             selectionMode="single"
             [loading]="false"
             [loadingIcon]="null"
             [showLoader]="false"
             [lazy]="true"
             (onLazyLoad)="lazyLoad($event)"
             [paginator]="false"
             [rows]="rows"
             [totalRecords]="rowCount"
             (onRowSelect)="rowChangePreview($event.data.guid)">
      <ng-template pTemplate="header">
        <tr>
          <th id="quote-list-width" [attr.width]="rowTools.width" [style.min-width]="rowTools.width"></th>
          <th id="quote-list-sortable" *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortable ? col.key : null" [attr.width]="col.width" [style.min-width]="col.width">
            <table>
              <tbody>
                <th id="quote-list-name" class="th-display-none"></th>
                <tr>
                  <td style="width:22px">
                    <p-sortIconCustom *ngIf="col.sortable === true" [field]="col.key"></p-sortIconCustom>
                  </td>
                  <td>
                    {{col.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="loadingbody" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            <loading></loading>Loading...
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="numColumns" style="text-align: center">
            No records found
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr [pSelectableRow]="item" (mouseenter)="hover = item.id" (mouseleave)="hover = null">
          <td>
            <row-tools [tools]="rowTools" [item]="item" (onClick)="clickRowTools($event)" [visible]="hover == item.id"></row-tools>
          </td>
          <td *ngFor="let col of visibleColumns">
            <dynamic-value [data]="item" [column]="col"></dynamic-value>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)"></paginator-custom>
  </div>
</div>
<p-dialog [(visible)]="showModal" [style]="{width: '50vw'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <quote-form *ngIf="showModal" [id]="selection == null ? 0 : selection?.id" (onCancel)="cancel()" (onSaveComplete)="complete()"></quote-form>
</p-dialog>
<p-dialog [(visible)]="showUserModal" [style]="{width: '50vw'}" [modal]="true" [showHeader]="false" [closable]="false">
  <user-form *ngIf="showUserModal" [id]="null" (onCancel)="cancel()" (onSaveComplete)="cancel();"></user-form>
</p-dialog>
<p-dialog  #orderDialog [(visible)]="showOrderModal" [style]="{'width': '70vw', 'min-width': '750px' }" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <order-form *ngIf="showOrderModal" [dialog]="dialogRef" [id]="null" (onCancel)="cancel()" (onSaveComplete)="cancel();"></order-form>
</p-dialog>
<p-dialog #locationDialog [(visible)]="showLocationModal" [style]="{width: '50vw'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <location-form *ngIf="showLocationModal" [id]="null" (onCancel)="cancel()" (onSaveComplete)="complete()"></location-form>
</p-dialog>

